import { iaSlice } from './ia.slice.ts';

export const { setCurrentEntry } = iaSlice.actions;
export const { setIADataSet } = iaSlice.actions;
